import React, { useState, useEffect } from 'react';
import Axiosfetch from '../Common/Axiosfetch';
import baseURL from '../Common/Config';
import FailureAlert from '../Common/Failure';
import { faBriefcase, faEnvelope, faGlobe, faPhoneVolume, faUser, faUserCircle, faTimes, faIdCard, faFileExcel } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import QRCode from 'qrcode.react';
import PickNTrackLogo from '../../Images/PickNTrackLogo.jpeg';
import * as htmlToImage from 'html-to-image';
import ReactExport from "react-export-excel";
import moment from 'moment';
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const UserList = ({ fullAllow }) => {
    const [usersData, setusersData] = useState([]);
    const [ExportData, setExportData] = useState([]);
    const [FilterUsers, setFilterUsers] = useState([]);
    const [SelectedUsers, setSelectedUsers] = useState({});
    useEffect(() => {
        FetchUsersData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const ExcelExport = () => {
        return (
            <ExcelFile element={<FontAwesomeIcon className='cursorpointer' style={{ fontSize: "20px" }}
                title='Export to Excel' icon={faFileExcel}></FontAwesomeIcon>}>
                <ExcelSheet data={ExportData} name="MFI Members">
                    <ExcelColumn label="MEMBER" value="Member" />
                    <ExcelColumn label="FULL NAME" value="FullName" />
                    <ExcelColumn label="ORGANIZATION" value="Organization" />
                    <ExcelColumn label="CONTACT NO." value="Contact" />
                </ExcelSheet>
            </ExcelFile>
        );
    }

    const FetchUsersData = () => {
        Axiosfetch(baseURL + "GetActivatedUsersByAnanymous", "GET", null, UserSuccess, Failure);
    };

    const UserSuccess = (data) => {
        if (data && data.length > 0) {
            setusersData(data);

            data.sort((a, b) => {
                var textA = a.Organization && a.Organization.length > 0 ? a.Organization[0].City : "";
                var textB = b.Organization && b.Organization.length > 0 ? b.Organization[0].City : "";
                return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
            })

            var exportTheExcel = [];

            data.forEach(element => {
                if (element.Organization && element.Organization.length > 0) {
                    exportTheExcel.push({
                        Member: `MFI ${element.Organization[0].City.toUpperCase()}`,
                        FullName: `${element.FirstName.toUpperCase()} ${element.LastName.toUpperCase()}`,
                        Organization: element.Organization[0].Name.toUpperCase(),
                        Contact: element.PhoneNumber.toString().toUpperCase()
                    })
                }
            });

            exportTheExcel.push({
                Member: "",
                FullName: "",
                Organization: "",
                Contact: ""
            })

            exportTheExcel.push({
                Member: `Export Date : ${moment().format("DD/MM/YYYY hh:mm:ss A")}`,
                FullName: "",
                Organization: "",
                Contact: ""
            })

            exportTheExcel.push({
                Member: "Note : Verify Online Directory before choosing Members",
                FullName: "",
                Organization: "",
                Contact: ""
            })

            setExportData(exportTheExcel);

            setFilterUsers(data);
        }
        else {
            setusersData([]);
            setFilterUsers([]);
        }
    };

    const onUsersSearch = (searchValue) => {
        if (searchValue !== "") {
            let userSearchData = usersData.filter(c => c.FirstName.trim().toLowerCase().includes(searchValue.trim().toLowerCase()) ||
                c.LastName.trim().toLowerCase().includes(searchValue.trim().toLowerCase()) ||
                (c.Organization.length > 0 && c.Organization[0].Name.trim().toLowerCase().includes(searchValue.trim().toLowerCase())) ||
                (c.Organization.length > 0 && c.Organization[0].Keywords !== null && c.Organization[0].Keywords.trim().toLowerCase().includes(searchValue.trim().toLowerCase())) ||
                (c.Organization.length > 0 && c.Organization[0].City !== null && c.Organization[0].City.trim().toLowerCase().includes(searchValue.trim().toLowerCase())));
            setFilterUsers(userSearchData);
        }
        else {
            setFilterUsers(usersData);
        }
    };

    const Failure = (err) => {
        FailureAlert(err);
    };

    const onWebSiteClick = (website) => {
        if (website !== "") {
            window.open((website.indexOf("http") === -1 ? "http://" : "") + website);
        }
    };

    const onUsersClose = () => {
        setSelectedUsers({});
    }

    const DownloadImage = () => {
        var node = document.getElementById('QRCodeImage');

        htmlToImage.toPng(node)
            .then(function (dataUrl) {
                var link = document.createElement('a');
                link.download = SelectedUsers.UserName + '_QRImage.png';
                link.href = dataUrl;
                link.click();
            })
            .catch(function (error) {
                console.error('oops, something went wrong!', error);
            });
    }

    return (
        <div>
            <div className='row no-gutters'>
                {SelectedUsers?._id !== undefined || (<div className='user-list col-md-5 pr-0' style={{ position: "relative", height: "68vh", overflow: "auto", borderRight: "1px solid #ccc" }}>
                    <div className='userbtnAvatar-root'>
                        <div className='d-flex'>
                            <input type="text" name="Name" placeholder="Search by City..."
                                className="input-control me-2" style={{ outline: "none", paddingLeft: "40px", borderTop: "none", borderTopLeftRadius: "0", borderTopRightRadius: "0" }}
                                onChange={e => onUsersSearch(e.target.value)}></input>
                            <div className='p-2'><ExcelExport></ExcelExport></div>
                        </div>
                        {FilterUsers && FilterUsers.length > 0 && FilterUsers.map(user => (
                            <div onClick={() => setSelectedUsers(user)} key={user._id}
                                className={`MuiListItem-button MuiListItem-root ${(SelectedUsers._id !== undefined && SelectedUsers._id === user._id) ? "active" : ""}`}>
                                <div className='userUIAvatar-root'>
                                    {user.Organization && user.Organization.length > 0 && user.Organization[0].Logo ? (<div style={{ borderRadius: "30px" }} className="cursor"><img width="45" height="45" alt="Logo" src={`${baseURL}OrgLogo/${user.Organization[0].Logo}`}></img></div>) :
                                        (<div style={{ borderRadius: "30px" }} className="avatar-soft-danger">
                                            <span className='avatar-initials cursor'>
                                                {`M${user.Organization && user.Organization.length > 0 ? user.Organization[0].City.charAt(0) : ""}`}
                                            </span>
                                        </div>)}

                                </div>
                                <div className="MuiListItemText-root MuiListItemText-multiline">
                                    <span className="MuiTypography-root MuiListItemText-primary MuiTypography-body1 MuiTypography-displayBlock">
                                        {`MFI ${user.Organization && user.Organization.length > 0 ? user.Organization[0].City : ""}`}
                                    </span>
                                    <p className="MuiTypography-root MuiListItemText-secondary MuiTypography-body2 MuiTypography-colorTextSecondary MuiTypography-displayBlock">
                                        {user.Organization && user.Organization.length > 0 ? user.Organization[0].Name : ""}
                                    </p>
                                </div>
                            </div>

                        ))}
                    </div>
                </div>)}
                <div className={`user-list ${SelectedUsers && SelectedUsers._id ? " col-md-12" : "col-md-7"} p-0`} style={{ height: "65vh", overflow: "auto" }}>
                    {SelectedUsers && SelectedUsers._id && (
                        <ul className='p-0 pt-2'>
                            {SelectedUsers.Organization && SelectedUsers.Organization.length > 0 && (
                                <li style={{ position: "relative" }} className="bbgray MuiListItem-root MuiListItem-gutters">
                                    <div className="MuiListItemAvatar-root">
                                        <div className="MuiAvatar-root MuiAvatar-circular jss1403 MuiAvatar-colorDefault">
                                            <FontAwesomeIcon icon={faIdCard}></FontAwesomeIcon>
                                        </div>
                                    </div>
                                    <div className="MuiListItemText-root MuiListItemText-multiline">
                                        <span className="MuiTypography-root MuiTypography-body1 text-uppercase">
                                            {SelectedUsers._id}
                                        </span>
                                        <p className="MuiTypography-colorTextSecondary MuiTypography-root MuiTypography-body2">Member ID</p>
                                    </div>
                                    <div className='cursorpointer' style={{
                                        fontSize: "1.5rem", position: "absolute",
                                        right: "20px"
                                    }} onClick={onUsersClose}><FontAwesomeIcon icon={faTimes}></FontAwesomeIcon></div>
                                </li>)}
                            {SelectedUsers.Organization && SelectedUsers.Organization.length > 0 && (
                                <li style={{ position: "relative" }} className="bbgray MuiListItem-root MuiListItem-gutters">
                                    <div className="MuiListItemAvatar-root">
                                        <div className="MuiAvatar-root MuiAvatar-circular jss1403 MuiAvatar-colorDefault">
                                            <FontAwesomeIcon icon={faUser}></FontAwesomeIcon>
                                        </div>
                                    </div>
                                    <div className="MuiListItemText-root MuiListItemText-multiline">
                                        <span className="MuiTypography-root MuiTypography-body1">
                                            {`MFI ${SelectedUsers.Organization[0].City}`}
                                        </span>
                                        <p className="MuiTypography-colorTextSecondary MuiTypography-root MuiTypography-body2">Partner Name</p>
                                    </div>
                                </li>)}
                            {SelectedUsers.Organization && SelectedUsers.Organization.length > 0 && (
                                <li className="bbgray MuiListItem-root MuiListItem-gutters">
                                    <div className="MuiListItemAvatar-root">
                                        <div className="MuiAvatar-root MuiAvatar-circular jss1402 MuiAvatar-colorDefault">
                                            <FontAwesomeIcon icon={faBriefcase}></FontAwesomeIcon>
                                        </div>
                                    </div>
                                    <div className="MuiListItemText-root MuiListItemText-multiline">
                                        <span className="MuiTypography-root MuiTypography-body1">
                                            {SelectedUsers.Organization[0].Name}
                                        </span>
                                        <p className="MuiTypography-colorTextSecondary MuiTypography-root MuiTypography-body2">Organization</p>
                                    </div>
                                </li>)}
                            {SelectedUsers.Organization && SelectedUsers.Organization.length > 0 && (
                                <li className="bbgray MuiListItem-root MuiListItem-gutters">
                                    <div className="MuiListItemAvatar-root">
                                        <div className="MuiAvatar-root MuiAvatar-circular jss1401 MuiAvatar-colorDefault">
                                            <FontAwesomeIcon icon={faUserCircle}></FontAwesomeIcon>
                                        </div>
                                    </div>
                                    <div className="MuiListItemText-root MuiListItemText-multiline">
                                        <span className="MuiTypography-root MuiTypography-body1">
                                            {SelectedUsers.Organization[0].GSTNumber}
                                        </span>
                                        <p className="MuiTypography-colorTextSecondary MuiTypography-root MuiTypography-body2">GST Number</p>
                                    </div>
                                </li>)}
                            <li className="bbgray MuiListItem-root MuiListItem-gutters">
                                <div className="MuiListItemAvatar-root">
                                    <div className="MuiAvatar-root MuiAvatar-circular jss1399 MuiAvatar-colorDefault">
                                        <FontAwesomeIcon icon={faPhoneVolume}></FontAwesomeIcon>
                                    </div>
                                </div>
                                <div className="MuiListItemText-root MuiListItemText-multiline">
                                    <span className="MuiTypography-root MuiTypography-body1">
                                        <a style={{ textDecoration: "none", color: "rgb(33,37,41)" }} href={`tel:+91${SelectedUsers.PhoneNumber}`}>{SelectedUsers.PhoneNumber}</a>
                                    </span>
                                    <p className="MuiTypography-colorTextSecondary MuiTypography-root MuiTypography-body2">Phone</p>
                                </div>
                            </li>
                            <li className="bbgray MuiListItem-root MuiListItem-gutters">
                                <div className="MuiListItemAvatar-root">
                                    <div className="MuiAvatar-root MuiAvatar-circular jss1400 MuiAvatar-colorDefault">
                                        <FontAwesomeIcon icon={faEnvelope}></FontAwesomeIcon>
                                    </div>
                                </div>
                                <div className="MuiListItemText-root MuiListItemText-multiline">
                                    <span className="MuiTypography-root MuiTypography-body1">
                                        {SelectedUsers.EmailID}
                                    </span>
                                    <p className="MuiTypography-colorTextSecondary MuiTypography-root MuiTypography-body2">Email ID</p>
                                </div>
                            </li>
                            {SelectedUsers.Organization && SelectedUsers.Organization.length > 0 && (
                                <li className="bbgray MuiListItem-root MuiListItem-gutters">
                                    <div className="MuiListItemAvatar-root">
                                        <div className="MuiAvatar-root MuiAvatar-circular jss1404 MuiAvatar-colorDefault">
                                            <FontAwesomeIcon icon={faGlobe}></FontAwesomeIcon>
                                        </div>
                                    </div>
                                    <div className="MuiListItemText-root MuiListItemText-multiline">
                                        <span onClick={() => onWebSiteClick(SelectedUsers.Organization[0].Website)} className="cursorpointer MuiTypography-root MuiTypography-body1">
                                            {SelectedUsers.Organization[0].Website}
                                        </span>
                                        <p className="MuiTypography-colorTextSecondary MuiTypography-root MuiTypography-body2">Website</p>
                                    </div>
                                </li>
                            )}
                            {/* {fullAllow === 1 && SelectedUsers && SelectedUsers.Organization &&
                                SelectedUsers.Organization.length > 0 && (
                                    <li className="bbgray MuiListItem-root MuiListItem-gutters">

                                        <div style={{ position: "relative" }} className="MuiListItemText-root MuiListItemText-multiline">
                                            <img alt="Logo" style={{ position: "absolute", left: "35%", top: "42%", borderRadius: "50%" }} width="35" src={PickNTrackLogo}></img>
                                            <QRCode renderAs="svg" bgColor="white" size={160}
                                                includeMargin={true} level="M"
                                                value={`http://${window.location.hostname}/PartnerDirectory`} />
                                        </div>
                                    </li>
                                )} */}
                        </ul>
                    )}
                    {(SelectedUsers._id === null || SelectedUsers._id === undefined) &&
                        (
                            <div onClick={DownloadImage} title="Click to download..."
                                style={{
                                    textAlign: "center", padding: "10px", minWidth: "300px", width: "30%", margin: "auto",
                                    borderRadius: "25px", border: "none", position: 'relative', marginTop: "20px"
                                }}>
                                <div id="QRCodeImage" style={{ borderRadius: "25px" }} className="cd-cards2 cd-cardboundry cursor">
                                    <div style={{ fontSize: "2rem", color: "white", lineHeight: "60px" }}>Scan</div>
                                    <div style={{ fontSize: "1.5rem", color: "white", marginBottom: "10px" }}>#mfimovers Network</div>
                                    <div style={{ position: "relative", marginLeft: "1px" }} className="MuiListItemText-root MuiListItemText-multiline">
                                        <img alt="Logo" style={{ position: "absolute", left: "42%", top: "42%", borderRadius: "50%" }} width="35" src={PickNTrackLogo}></img>
                                        <QRCode renderAs="svg" bgColor="white" size={170}
                                            includeMargin={true} level="M"
                                            value={`http://${window.location.hostname}/PartnerDirectory`} />
                                    </div>
                                    <div className='mt-2 mb-2' style={{ color: "white" }}>www.moversfederation.org</div>
                                </div>
                            </div>

                            // <div style={{ position: "absolute", left: "30%", top: "28%" }} className='userDirMobile text-center pt-2'>
                            //     <img height="150px" width="auto" src={Verification}></img>
                            //     <h5 className='ml-2 mr-2 mt-2'>Please select #mfimovers...</h5>
                            // </div>
                        )}
                </div>
            </div>
        </div>
    );
};

export default UserList;